import { logError } from './common'

declare global {
  // tslint:disable-next-line
  interface Window {
    Stripe: any
  }
}

interface ICreditCardData {
  stripeToken: string
}

interface ICreditCard {
  address_country: string
  address_zip: string
  cvc: string
  exp: string
  number: string
}

const ERROR = [
  'We are having problems contacting the credit card processor.',
  'Please try again, or contact us at hello@wonderschool.com.',
].join(' ')

export function createCreditCard(creditCard: ICreditCard): Promise<ICreditCardData> {
  return new Promise((resolve, reject) => {
    if (!window.Stripe) {
      logError('Stripe not initialized')
      reject([ERROR])
      return
    }

    window.Stripe.card.createToken(creditCard, (status: string, response: any) => {
      if (response.error) {
        logError('Error from stripe', { status, response })
        reject([response.error.message])
        return
      }

      resolve({ stripeToken: response.id })
    })
  })
}
